import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Law} from "../../models/laws";
import {Registration} from "../../models/registration";
import {RegistrationLaw} from "../../models/registration-law";

@Directive()
@Injectable()
export class LawService {

  public serviceId: any;
  public registration: Registration;
  public law: Law;
  public laws: Law[];
  public registrationLaw: RegistrationLaw;
  public registrationLawList: RegistrationLaw[];
  public addNew: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      law: this.law,
      registrationLaw: this.registrationLaw,
      addNew: this.addNew,
    });
  }

  public initData() {
    this.change.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      registrationLawList: this.registrationLawList,
      laws: this.laws,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
